import Home from "./Home/Home";
import WsContainer from "./WsContainer";
import { Navigate } from "react-router-dom";

const RouteProtector = () =>{
const token = localStorage.getItem("SavedToken");

const returnValue = token ? <Navigate to="/home"/> : <Navigate to="/login"/>
return returnValue;
}

export default RouteProtector;